import React, { useEffect, useRef, useState } from "react";
import "../styles/Header/Header.css";
import { useLocation, useNavigate } from "react-router-dom";

const Header = ({ title, links = [], onLogoClick }) => {
  const myRef = useRef(null);
  const navigate = useNavigate();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const previousPage = sessionStorage.getItem("previousPage");
    console.log("Previous Page on Load:", previousPage);
  
    if (previousPage && location.pathname === "/404") {
      navigate(previousPage || "/");
    }
  }, [navigate, location.pathname]);

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleNavigation = (url, isRedirect) => {
    setIsNavOpen(false); // Close menu before navigation

    if (isRedirect) {
      window.location.href = url;
      return;
    }
    navigate(url);
    window.scrollTo(0, 0);
  };

  const toggleMenu = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <>
      <header className="header">
        <div className="logo" onClick={onLogoClick}>
          <img src="./lovencoders.svg" alt="logo" className="logoImg" />
          <h1>
            <span style={{ color: "#ff0400" }}>LOVE</span>
            <span>NCODERS</span>
          </h1>
        </div>
        <nav className="nav">
          <ul className="nav-links">
            {links.map((link, index) => (
              link.isHeader && (
                <li key={index} style={{ position: "relative" }}>
                  {link.scrollId ? (
                    <span
                      onClick={() => handleScroll(link.scrollId)}
                      style={{ cursor: "pointer", color: "white" }}
                    >
                      {link.label}
                    </span>
                  ) : (
                    <button
                      onClick={() => {
                        if (isNavOpen) setIsNavOpen(false); // Ensure menu closes before navigation
                        if (link.onClick) link.onClick(); // Custom click handling
                        handleNavigation(link.url, link.isRedirect);
                      }}
                      className={`${
                        location.pathname === link.url
                          ? "active-link"
                          : "not-active-link"
                      }`}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      {link.label}
                    </button>
                  )}
                </li>
              )
            ))}
          </ul>
        </nav>

        <div id="hamburger" onClick={toggleMenu}>
          <div
            className={`hamburger-container ${isNavOpen ? "change" : ""}`}
            ref={myRef}
          >
            <div className="bar1"></div>
            <div className="bar2"></div>
            <div className="bar3"></div>
          </div>
        </div>

        <div className={`navigation-overlay ${isNavOpen ? "open" : ""}`}>
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url || `#${link.scrollId}`}
              onClick={(e) => {
                e.preventDefault(); // Prevent default behavior for smooth handling
                if (isNavOpen) setIsNavOpen(false); // Close menu before clicking links
                if (link.onClick) link.onClick();
                link.url
                  ? handleNavigation(link.url, link.isRedirect)
                  : handleScroll(link.scrollId);
              }}
            >
              {link.label}
            </a>
          ))}
        </div>
      </header>
    </>
  );
};

export default Header;
